import PropTypes from 'prop-types';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import SubscriptionsList from './list/subscriptionsList';
import PageError from '../error/pageError';
import CreateWebservice from './create/createWebservice';
import EditWebservice from './editWebservice';

export default function WebserviceOrganization({ organization, path, history }) {
    return (
        <Switch>
            <Route exact path={`${path}/`} render={() => <SubscriptionsList organizationId={organization.id} />} />
            <Route exact path={`${path}/new`} render={() => <CreateWebservice organizationId={organization.id} />} />
            <Route
                exact
                path={`${path}/edit/:subscriptionId([0-9]+)`}
                render={({
                    match: {
                        params: { subscriptionId }
                    }
                }) => <EditWebservice subscriptionId={subscriptionId} organization={organization} history={history} />}
            />
            {/* Error */}
            <Route render={() => <PageError errorCode={404} backHomeUrl={`/ticket/O${organization.id}`} />} />
        </Switch>
    );
}

WebserviceOrganization.propTypes = {
    organization: PropTypes.object.isRequired,
    path: PropTypes.string.isRequired
};
